import { ADD_DOCUMENTS, ASSIGN_TEAM, ASSIGN_USER, DOCUMENTS_DELETE, DOCUMENTS_EDIT, DOCUMENTS_LIST, DOCUMENTS_VIEW, FOLDERS_LIST, GET_DOCUMENT_SUMMARY, TEAMS_DROP_DOWN, TRANSLATE_SUMMARY, UPLOAD_FILE, USERS_DROP_DOWN } from "./types";



export const documentsListAction = (data, onSuccess, onError) => {
    return {
        type: DOCUMENTS_LIST,
        data,
        onSuccess,
        onError,
    };
};
export const addDocumentsAction = (data, onSuccess, onError) => {
    return {
        type: ADD_DOCUMENTS,
        data,
        onSuccess,
        onError
    }
};

export const documentsEdit = (data, onSuccess, onError) => {
    return {
        type: DOCUMENTS_EDIT,
        data,
        onSuccess,
        onError,
    };
};


export const documentsDelete = (data, onSuccess, onError) => {
    return {
        type: DOCUMENTS_DELETE,
        data,
        onSuccess,
        onError,
    };
};

export const documentsView = (data, onSuccess, onError) => {
    return {
        type: DOCUMENTS_VIEW,
        data,
        onSuccess,
        onError,
    };
};

export const uploadFile = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_FILE,
        file,
        onSuccess,
        onError,
    };
};

export const foldersDropDown = (data, onSuccess, onError) => {
    return {
        type: FOLDERS_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const teamsDropDown = (data, onSuccess, onError) => {
    return {
        type: TEAMS_DROP_DOWN,
        data,
        onSuccess,
        onError,
    };
};

export const assignTeamAction = (data, onSuccess, onError) => {
    return {
        type: ASSIGN_TEAM,
        data,
        onSuccess,
        onError,
    };
};

export const assignUserAction = (data, onSuccess, onError) => {
    return {
        type: ASSIGN_USER,
        data,
        onSuccess,
        onError,
    };
};

export const usersDropDown = (data, onSuccess, onError) => {
    return {
        type: USERS_DROP_DOWN,
        data,
        onSuccess,
        onError,
    };
};

export const documentSummary = (data, onSuccess, onError) => {
    return {
        type: GET_DOCUMENT_SUMMARY,
        data,
        onSuccess,
        onError,
    };
};

export const translateSummary = (data, onSuccess, onError) => {
    return {
        type: TRANSLATE_SUMMARY,
        data,
        onSuccess,
        onError,
    };
};